export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7014.8ceab1dc.jpg";